import React from "react";
import PremiumResourcePage, { resourceMoney, resourceStatus } from "../../../Components/Dashboard/PremiumResourcePage";
import ProformaUpdate from "./ProformaUpdate";

function Proforma({ navigation }) {
  return (
    <PremiumResourcePage
      navigation={navigation}
      title="Pro Forma"
      subtitle="Manage pro forma invoices before final billing."
      createRoute="ProformaNew"
      createLabel="+ New Pro Forma"
      fetchEndpoint="/fetchProFormaInvoice"
      documentType="pro_forma"
      deleteEndpoint="/deleteProFormaByInvoiceNumber/:id"
      deleteKey="invoiceNumber"
      totalKey="total"
      renderEdit={(row, handleCancel) => (
        <ProformaUpdate
          invoiceNumber1={row.invoiceNumber}
          fetchedStatus={row.status}
          handleCancel={handleCancel}
        />
      )}
      columns={[
        { key: "invoiceDate", label: "Date" },
        { key: "invoiceNumber", label: "Pro Forma #" },
        { key: "orderNumber", label: "Order Number" },
        { key: "customerName", label: "Customer Name" },
        { key: "status", label: "Status", render: (row) => resourceStatus(row.status) },
        { key: "dueDate", label: "Due Date" },
        { key: "total", label: "Amount", className: "premium-money", render: (row) => resourceMoney(row.total) },
      ]}
    />
  );
}

export default Proforma;
